module.exports = __webpack_public_path__ + "img/home2.3b74787e.png";